import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { CustomToastService } from '../services/toast.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private authService: AuthService,
    private customToastr: CustomToastService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const skipUrls = ['/audit/save-log'];
    const shouldSkip = skipUrls.some(url => request.url.includes(url));

    if (!shouldSkip) {
        const token = this.authService.getToken();

        if (token) {
          // Pre-flight integrity check: catches locally-tampered session
          // data (role/username edited in storage without a matching
          // token) before the request ever reaches the backend.
          const mismatchReason = this.authService.checkIntegrityMismatch();
          if (mismatchReason) {
            this.authService.handleForcedLogout(`${mismatchReason}`);
            return throwError(() => new Error('Blocked: integrity mismatch detected'));
          }

          request = request.clone({
              setHeaders: { Authorization: `Bearer ${token}` }
          });
        }
    }

    return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401 && !shouldSkip) {
              this.authService.clearSession();
              this.router.navigate(['/features/login']);
          }

          if (error.status === 403 && !shouldSkip) {
              this.router.navigate(['/not-found']);
          }
          return throwError(() => error);
        })
    );
  }
}